/* P120 cart drawer upsell — adds one more of the product already in the cart.
   Uses /cart/change.js so Kaching Bundles line item properties survive and the
   line is incremented instead of a second line being created. */
(function () {
  if (window.p120UpsellAdd) return;

  function drawerNode(doc) {
    return (doc || document).querySelector('#shopify-section-cart-drawer');
  }

  window.p120UpsellAdd = async function (btn) {
    if (!btn || btn.disabled) return;
    var root = btn.closest('[data-p120-upsell]');
    if (!root) return;

    var variantId = parseInt(root.getAttribute('data-variant'), 10);
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });

      var idx = -1;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === variantId) { idx = i + 1; break; }
      }

      if (idx > 0) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: idx, quantity: cart.items[idx - 1].quantity + 1 })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      }

      var html = await fetch(window.location.pathname + '?section_id=cart-drawer').then(function (r) { return r.text(); });
      var fresh = drawerNode(new DOMParser().parseFromString(html, 'text/html'));
      var current = drawerNode(document);

      if (fresh && current) {
        // The swap recreates <cart-drawer>, which drops the open state. Carry it over.
        var openEl = current.querySelector('cart-drawer');
        var openClass = openEl ? openEl.className : '';

        current.innerHTML = fresh.innerHTML;

        var newEl = current.querySelector('cart-drawer');
        if (newEl && openClass) newEl.className = openClass;

        document.dispatchEvent(new CustomEvent('p120:cart-updated'));
      } else {
        window.location.reload();
      }
    } catch (e) {
      btn.disabled = false;
      btn.textContent = original;
    }
  };
})();
